import { useState } from "react";
import axios from "axios";
import { z } from "zod";
import api from "@/store/api";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";

const useRegister = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const RegisterSchema = z.object({
    nickName: z
      .string()
      .min(1, t("authentication.validation.usernameRequired")),
    email: z.string().email(t("authentication.validation.invalidEmail")),
    password: z
      .string()
      .min(8, t("authentication.changePassword.validation.passwordLength")),
    role: z.string(),
  });
  const register = async (values: z.infer<typeof RegisterSchema>) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await api.post("/web/auth/register", values);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        setError(
          err.response?.data?.message || t("alerts.error.registrationError")
        );
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };

  return { register, isLoading, error };
};

export default useRegister;
